var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3771 4.28601C9.63734 0.0257564 16.5446 0.0257548 20.8049 4.28602C25.0651 8.54627 25.0651 15.4535 20.8049 19.7138C16.5446 23.974 9.63735 23.974 5.3771 19.7138C4.95107 19.2877 4.95107 18.597 5.3771 18.171C5.80312 17.745 6.49385 17.745 6.91987 18.171C10.3281 21.5792 15.8539 21.5792 19.2621 18.171C22.6703 14.7628 22.6703 9.23699 19.2621 5.82879C15.8539 2.42058 10.3281 2.42058 6.91988 5.82879C5.21447 7.5342 4.36262 9.76757 4.36372 12.0042L4.3637 14.1817C4.36369 14.7842 3.87527 15.2726 3.27278 15.2726C2.67029 15.2726 2.18188 14.7841 2.18188 14.1816L2.18191 12.005C2.18191 12.0049 2.18191 12.0051 2.18191 12.005C2.18068 9.2132 3.24595 6.41716 5.3771 4.28601Z",
    fill: "#aaaaaa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.319519 11.2287C0.745545 10.8027 1.43627 10.8027 1.86229 11.2287L3.27272 12.6391L4.68315 11.2287C5.10917 10.8027 5.7999 10.8027 6.22592 11.2287C6.65195 11.6547 6.65195 12.3454 6.22592 12.7715L4.04411 14.9533C3.61808 15.3793 2.92736 15.3793 2.50133 14.9533L0.319519 12.7715C-0.106506 12.3454 -0.106506 11.6547 0.319519 11.2287Z",
    fill: "#aaaaaa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 6.54541C12.6026 6.54541 13.091 7.03383 13.091 7.63632V11.9999H17.4546C18.0571 11.9999 18.5455 12.4883 18.5455 13.0908C18.5455 13.6933 18.0571 14.1817 17.4546 14.1817H12.0001C11.3976 14.1817 10.9092 13.6933 10.9092 13.0908V7.63632C10.9092 7.03383 11.3976 6.54541 12.0001 6.54541Z",
    fill: "#aaaaaa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f2b246a4262c4a2bd8a9ac4c5a4db6a3.svg";
export { ForwardRef as ReactComponent };